/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import {
  UpdateProductDrawer,
  UpdateProductDrawerType,
} from "./UpdateProductDrawer";
import { Product } from "../models/product";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

type Props = {
  product: Product;
  type: UpdateProductDrawerType;
  drawerTitle: string;
};

export const UpdateProductSelector = ({
  product,
  type,
  drawerTitle,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary
        onClick={() => setModalOpen(true)}
        type="button"
        icon={<FontAwesomeIcon icon={solid("pen")} />}
      >
        Edit
      </ButtonPrimary>
      <UpdateProductDrawer
        isOpen={modalOpen}
        handleOnClose={() => setModalOpen(false)}
        product={product}
        type={type}
        drawerTitle={drawerTitle}
      />
    </div>
  );
};
